import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import StockProductsSection from "./stock-products-section";

export default function StockProductsPage() {
  return (
    <>
      <Header />
      <StockProductsSection />
    </>
  );
}
